<template>
  <div class='attachments'>
    <span class='label' :style='labelStyle'>{{labelText}}:</span>
    <div class='attachmentsContent'>
      <el-upload
        class='avatar-uploader'
        :action="attachmentsUploadUrl"
        :show-file-list='false'
        :on-success='cropUploadSuccess'
        :on-error="errorCallback"
        :headers="header"
        accept=".jpg,.png,.jpeg"
      >
        <img v-if='value' :src='value' class='avatar'>
        <i v-else class='el-icon-plus avatar-uploader-icon'></i>
      </el-upload>
      <span class="text">{{text}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'anyImageUpload',
  props: {
    label: String,
    value: '',
    labelWidth: String,
    width: Number,
    height: Number,
    type: Number,
    text: String,
  },
  data () {
    return {
      header: {
        token: CookieManage.get('token') || '', // 用户token
      },
      imageUrl: this.value,
      showBigImage: false,
      // attachmentsUploadUrl: window.pubServer + '/upload/upload',
      attachmentsUploadUrl: window.uploadUrl,
      // attachmentsUploadUrl: 'https://uat-nikegetit2.nike.com.cn/public-service-new/upload/upload',
      labelText: this.label || '图片上传',
    }
  },
  methods: {
    cropUploadSuccess (jsonData, field) {
      console.log('jsonData', jsonData)
      if (jsonData.code === 200) {
        this.imageUrl = jsonData.data.url
        this.$emit('input', this.imageUrl)
      } else {
        this.$message.error(jsonData.message)
      }

    },
    errorCallback (error) {
      console.log('上传图片错误',error)
    }
  },
  computed: {
    labelStyle () {
      const w = this.labelWidth || '100'
      return {
        width: w + 'px'
      }
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.imageUrl = val
    },
    label: function (val, oldVal) {
      this.labelText = val
    }
  }
}
</script>

<style scoped lang='scss'>
  .attachments{
    display: flex;
    margin-bottom: 20px;
    .label{
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 36px;
      padding: 0 12px 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      flex-shrink: 0;
    }
    .input-box{
      font-size: 12px;
      color: #606266;
      span{
        margin-left: 5px;
      }
    }
    .attachmentsContent{
      line-height: 36px;
      width: 100%;
      .upload-image{
        width: 150px;
      }
      .text {
        font-size: 12px;
        line-height: 26px;
        color: #606266
      }

    }
  }
  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover{
    border-color: #409EFF;
  }

  .avatar-uploader-icon{
    font-size: 20px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    border: 1px dashed #ccc;
    background: #fff;
  }
  .avatar{
    width: 150px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/anyImageUpload.vue